<div
  class="fixed top-0 left-0 h-screen bg-white flex flex-col transition-all duration-300 border-r border-gray-100 z-10"
  [style.width]="isExpanded() ? '284px' : '80px'"
>
  <div class="mb-7 mt-7 w-full flex justify-center shrink-0 2xl:mb-10 2xl:mt-10">
    <img src="images/logos/logo-1.png" alt="Logo"
         class="object-contain w-[100px] md:w-[131px] 2xl:w-[150px] h-auto transition-all">
  </div>

  <div class="flex-grow overflow-y-auto px-2 2xl:px-4">
    <ul class="list-none p-0 m-0">
      <li *ngFor="let item of menuService.roleMenu()" class="mb-3 xl:mb-2">
        <ng-container *ngIf="item.children && item.children.length > 0">
          <div
            (click)="toggleItem(item)"
            class="flex items-center px-2 py-3.5 rounded-xl cursor-pointer transition-all duration-200 xl:py-3 xl:px-2"
            [ngClass]="isChildActive(item) ? 'bg-black text-[#EAB308]' : 'text-black'"
          >
            <i [class]="item.icon" class="text-xl mr-1 w-2 text-center shrink-0 xl:text-2xl 2xl:mr-5"></i>

            <typography
              *ngIf="isExpanded()"
              [variant]="'body-2'"
              weight="semibold"
              class="flex-grow xl:text-lg"
              [color]="isChildActive(item) ? 'text-[#EAB308]' : 'text-black'"
            >
              {{ item.label }}
            </typography>

            <i *ngIf="isExpanded()"
               class="pi ml-auto shrink-0 text-[9px]! xl:text-[14px]! mr-1"
               [ngClass]="isMenuExpanded(item)() ? 'pi-chevron-up' : 'pi-chevron-down'">
            </i>
          </div>

          <ul *ngIf="isMenuExpanded(item)() && isExpanded()"
              class="list-none m-0 p-0 mt-1 xl:mt-0">
            <li *ngFor="let child of item.children" class="relative">
              <a
                [routerLink]="child.url"
                routerLinkActive="active-child-state"
                #rla="routerLinkActive"
                class="child-link-custom flex items-center py-2 pl-20 2xl:pl-22 pr-4 no-underline relative text-gray-600 hover:text-gray-400 2xl:py-4"
              >
                <span
                  class="bullet-dot absolute left-14 w-1.5 h-1.5 rounded-full transition-colors 2xl:left-16 2xl:w-2 2xl:h-2"
                  [ngClass]="rla.isActive ? 'bg-[#EAB308]' : 'bg-gray-600'">
                </span>

                <typography
                  variant="body-2"
                  weight="semibold"
                  class="2xl:text-base"
                  [color]="rla.isActive ? 'text-[#EAB308]' : 'text-gray-600'"
                >
                  {{ child.label }}
                </typography>
              </a>
            </li>
          </ul>
        </ng-container>

        <ng-container *ngIf="!item.children || item.children.length === 0">
          <a
            [routerLink]="item.url"
            routerLinkActive="active-parent-state"
            #rlaSingle="routerLinkActive"
            [routerLinkActiveOptions]="{exact: true}"
            class="flex items-center px-2 py-3 rounded-xl no-underline transition-all 2xl:py-3 2xl:px-4"
            [ngClass]="rlaSingle.isActive ? 'bg-black text-[#EAB308]' : 'text-black hover:bg-gray-50'"
          >
            <i [class]="item.icon" class="text-xl mr-1 w-2 text-center shrink-0 2xl:text-2xl 2xl:mr-5"></i>

            <typography
              *ngIf="isExpanded()"
              variant="body-1"
              weight="semibold"
              class="2xl:text-lg"
              [color]="rlaSingle.isActive ? 'text-[#EAB308]' : 'text-black'"
            >
              {{ item.label }}
            </typography>
          </a>
        </ng-container>

      </li>
    </ul>
  </div>

  <div class="p-5 mt-auto border-t border-[#E0E0E0] 2xl:p-8">
    <button
      (click)="logout()"
      class="flex items-center w-full px-2 py-3 text-black hover:text-red-500 rounded-lg bg-transparent border-none cursor-pointer group 2xl:py-5"
      [class.justify-center]="!isExpanded()"
    >
      <i class="pi pi-power-off text-lg group-hover:text-red-500 mr-3 shrink-0 2xl:text-2xl 2xl:mr-5"></i>

      <typography
        *ngIf="isExpanded()"
        variant="body-1"
        weight="semibold"
        color="text-black"
        class="2xl:text-lg"
        customClass="group-hover:text-red-500"
      >
        Logout
      </typography>
    </button>
  </div>
</div>
